import React, { FC } from 'react'

import { IconDroneProps } from './IconDrone.types'
import * as Styled from './styles/IconDrone.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDrone: FC<IconDroneProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDroneProps['size'],
  isResponsive = false,
}: IconDroneProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M30.426 32.355a11.358 11.358 0 0 1-12.774.063m15.512 3.062a16.327 16.327 0 0 1-18.383.09'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M38 23.379c-5.023 0-10.031.777-10.031 4.683h-8C19.973 24.157 15 23.38 10 23.38m13.914-8.298H18v4h-7.852'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M30 19.086v-4h-6.086' stroke='#0D0D0D' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path d='M37.852 19.086H30' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M9.996 13.004v12.492M4.988 12.063h10.016m17.984 0h10.02M38 13.004v12.492'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M22.96 23.074h2.08' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDrone
